import styled from 'styled-components';

export default styled.div`
	position: relative;
	aside {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 0;
	}
`;
